import { ofType } from "redux-observable";
import { mergeMap, map, catchError } from "rxjs/operators";
import { of } from "rxjs";
import {
  deleteParameter,
  getParameters,
  postParameter,
  putParameter,
} from "./services";
import {
  actionTypes,
  deleteParameterFailure,
  deleteParameterSuccess,
  getParametersFailure,
  getParametersSuccess,
  postParameterFailure,
  postParameterSuccess,
  putParameterFailure,
  putParameterSuccess,
} from "./actions";

const fetchGetParameterEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.GET_PARAMETERS),
    mergeMap(() =>
      getParameters().pipe(
        map((response: any) => getParametersSuccess(response)),
        catchError((error: any) => of(getParametersFailure(error)))
      )
    )
  );

const postParameterEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.POST_PARAMETER),
    mergeMap((action: any) =>
      postParameter(action.payload).pipe(
        map((response: any) => postParameterSuccess(response)),
        catchError((error: any) => of(postParameterFailure(error)))
      )
    )
  );

const putParameterEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.PUT_PARAMETER),
    mergeMap((action: any) =>
      putParameter(action.payload).pipe(
        map((response: any) => putParameterSuccess(response)),
        catchError((error: any) => of(putParameterFailure(error)))
      )
    )
  );

const deleteParameterEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.DELETE_PARAMETER),
    mergeMap((action: any) =>
      deleteParameter(action.payload).pipe(
        map((response: any) => deleteParameterSuccess(response)),
        catchError((error: any) => of(deleteParameterFailure(error)))
      )
    )
  );

export default [
  fetchGetParameterEpic,
  postParameterEpic,
  putParameterEpic,
  deleteParameterEpic,
];
